import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ClipLoader from "react-spinners/ClipLoader";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import {
  useGetPointSettingsQuery,
  useUpdatePointSettingsMutation,
} from "../../Data/services/settingApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import styles from "./styles/StaticPage.module.scss";

const SetPoints = () => {
  const { handleSubmit, control, register, watch, reset } = useForm();

  const {
    data: settingData,
    isLoading,
    refetch,
  } = useGetPointSettingsQuery({
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    console.log(settingData);
    if (settingData && settingData?.data) {
      const { participation_points, win_points } = settingData?.data;
      reset({
        win_points: win_points || 0,
        participation_points: participation_points || 0,
      });
    }
  }, [settingData]);

  const [updateSetting, { isLoading: isUpdating }] =
    useUpdatePointSettingsMutation();

  const handleSaveText = async (data) => {
    // console.log(value
    console.log(data);
    try {
      const response = await updateSetting(data).unwrap();
      console.log(response);

      if (response?.code === 200) {
        SuccessToast("Settings updated successfully");
        refetch();
      } else {
        Toast("Failed to update settings");
      }
    } catch (error) {
      console.error("Error updating settings:", error);
      Toast("Error updating settings", error);
    }
  };

  return (
    <div className={styles.StaticPage}>
      <Form onSubmit={handleSubmit(handleSaveText)}>
        <Row>
          <Col sm={10}>
            <SubTitle text="Set Points" classes="mb-4" />
          </Col>
          <Col sm={2}>
            <Button
              text={
                isUpdating ? <ClipLoader color="#0f0f0f" size="22px" /> : "Save"
              }
              // classes={`${styles.cardBtn} `}
              classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
                isUpdating ? "bg-dark-subtle" : ""
              }`}
              disabled={isUpdating}
              type="submit"
              // onClick={handleSaveText}
            ></Button>
          </Col>
        </Row>

        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <ClipLoader color="#158e10" size="22px" />
          </div>
        ) : (
          <>
            <Row>
              <Col md={12}>
                <p className="m-0 ">Participation Points</p>
                <Controller
                  control={control}
                  name="participation_points"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="number"
                      placeholder="Enter points"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <p className="m-0 ">Win</p>
                <Controller
                  control={control}
                  name="win_points"
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Input
                      classes="mt-2 mb-3"
                      type="number"
                      placeholder="Enter points"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>
          </>
        )}
      </Form>
    </div>
  );
};

export default SetPoints;
